import { render, staticRenderFns } from "./Settings1.container.vue?vue&type=template&id=e6ccf918&scoped=true&"
import script from "./Settings1.container.vue?vue&type=script&lang=js&"
export * from "./Settings1.container.vue?vue&type=script&lang=js&"
import style0 from "./Settings1.container.vue?vue&type=style&index=0&id=e6ccf918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ccf918",
  null
  
)

export default component.exports